<template>
  <div class="container pb-4">
    <div class="row">
      <div class="col text-center">
        <h5 class="pt-0 pb-3">Congratulations!</h5>
      </div>
    </div>
    <div class="card">
      <div class="card-body text-center py-4">
        <img :src="product.image" style="height:5rem" />
        <div class="mt-3"><b>{{ product.name }}</b></div>
        <div class="mt-3">Your product has been created and is being reviewed</div>
        <div class="mt-3">Please check your email for confirmation and next steps</div>
        <div class="mt-3">
          <div class="row">
            <div class="col-md-6 p-2 text-md-right"><a :href="`/product/${product.id}/view`" class="btn btn-success px-3">See this product</a></div>
            <div class="col-md-6 p-2 text-md-left"><a href="/products/new" class="btn btn-dark px-3">Add another product</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template> 

<script>
import confetti from "canvas-confetti";

export default {
  props: ['product'],

  created() {
    this.triggerConfetti();
  },

  methods: {
    triggerConfetti() {
      const duration = 10 * 1000;

      confetti({
        particleCount: 100,
        spread: 160,
        origin: { y: 0.6 },
      });

      setTimeout(() => confetti.reset(), duration);
    },
  },
};
</script>